import React from 'react';
import './GitHub.css';

function GitHub() {
  const prSteps = [
    { num: '1', title: 'Fork / Clone', desc: 'Fes un fork del repositori o clona\'l al teu ordinador.', icon: '🔱' },
    { num: '2', title: 'Crea una branca', desc: 'Crea una branca nova per la teva funcionalitat.', icon: '🌿' },
    { num: '3', title: 'Fes commits', desc: 'Treballa i fes commits dels teus canvis.', icon: '💾' },
    { num: '4', title: 'Push', desc: 'Puja la teva branca al repositori remot.', icon: '⬆️' },
    { num: '5', title: 'Pull Request', desc: 'Obre un PR per proposar els teus canvis.', icon: '🔀' },
    { num: '6', title: 'Review & Merge', desc: "L'equip revisa i fusiona el teu codi.", icon: '✅' },
  ];

  return (
    <section id="github" className="github">
      <div className="container">
        <div className="section-header">
          <span className="section-tag">Col·laboracio</span>
          <h2 className="section-title"><span className="gold">GitHub</span> i treball en equip</h2>
          <p className="section-desc">
            GitHub es la plataforma mes popular per allotjar repositoris Git.
            Permet col·laborar amb altres desenvolupadors de manera eficient.
          </p>
        </div>

        <div className="github-features">
          <div className="gh-feature-card">
            <div className="gh-icon-wrap">
              <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <path d="M15 22v-4a4.8 4.8 0 0 0-1-3.5c3 0 6-2 6-5.5.08-1.25-.27-2.48-1-3.5.28-1.15.28-2.35 0-3.5 0 0-1 0-3 1.5-2.64-.5-5.36-.5-8 0C6 2 5 2 5 2c-.3 1.15-.3 2.35 0 3.5A5.403 5.403 0 0 0 4 9c0 3.5 3 5.5 6 5.5-.39.49-.68 1.05-.85 1.65-.17.6-.22 1.23-.15 1.85v4"/>
                <path d="M9 18c-4.51 2-5-2-7-2"/>
              </svg>
            </div>
            <h3>Repositoris</h3>
            <p>Allotja el teu codi al nuvol. Repositoris publics (open source) o privats per projectes personals.</p>
          </div>

          <div className="gh-feature-card">
            <div className="gh-icon-wrap">
              <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <circle cx="18" cy="18" r="3"/><circle cx="6" cy="6" r="3"/>
                <path d="M13 6h3a2 2 0 0 1 2 2v7"/><path d="M6 9v12"/>
              </svg>
            </div>
            <h3>Pull Requests</h3>
            <p>Proposa canvis al codi. Els companys poden revisar, comentar i aprovar abans de fusionar.</p>
          </div>

          <div className="gh-feature-card">
            <div className="gh-icon-wrap">
              <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/>
                <line x1="12" y1="16" x2="12.01" y2="16"/>
              </svg>
            </div>
            <h3>Issues</h3>
            <p>Registra bugs, tasques i millores. Assigna responsables i segueix el progres del projecte.</p>
          </div>

          <div className="gh-feature-card">
            <div className="gh-icon-wrap">
              <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
                <line x1="3" y1="9" x2="21" y2="9"/>
                <line x1="9" y1="21" x2="9" y2="9"/>
              </svg>
            </div>
            <h3>Projects</h3>
            <p>Organitza el treball amb taulers Kanban. Visualitza el progres de les tasques de lequip.</p>
          </div>
        </div>

        <div className="pr-workflow">
          <h3 className="pr-title">Flux de treball amb Pull Requests</h3>
          <div className="pr-steps">
            {prSteps.map((s, i) => (
              <div className="pr-step" key={i}>
                <div className="pr-step-icon">{s.icon}</div>
                <div className="pr-step-content">
                  <span className="pr-step-num">Pas {s.num}</span>
                  <h4>{s.title}</h4>
                  <p>{s.desc}</p>
                </div>
                {i < prSteps.length - 1 && (
                  <div className="pr-step-connector">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="var(--gold)" strokeWidth="2">
                      <path d="M5 12h14M12 5l7 7-7 7"/>
                    </svg>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        <div className="github-tip">
          <div className="tip-icon">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/>
              <line x1="12" y1="17" x2="12.01" y2="17"/>
            </svg>
          </div>
          <div className="tip-content">
            <h4>Consell important</h4>
            <p>
              Fes commits <strong>petits i frequents</strong> amb missatges descriptius.
              Es millor fer 10 commits petits que 1 commit gegant.
              Aixi es mes facil revisar el codi i trobar errors.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default GitHub;
